<template>
  <v-main>
    <RowDetailsDialog ref="detailsDialog" />

    <GenericReport
      ref="report"
      orientation="horizontal"
      hide-header
      class="clean-list"
      :reportSpec="reportSpec"
      @rowClicked="go"
      @reloaded="fetchStats"
    >
      <template v-slot:topbar-actions="{ checkDownload }">
        <v-spacer />
        <Indicators
          v-if="stats != null"
          :stats="stats"
          @click:pendingTicket="clickPendingTicket"
          @click:pendingChecklist="clickPendingChecklist"
        />
        <v-spacer />
        <v-btn icon @click="checkDownload"><v-icon>$excel</v-icon></v-btn>
      </template>
    </GenericReport>
  </v-main>
</template>

<script>
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import RowDetailsDialog from './RowDetailsDialog.vue'
import Indicators from './Indicators.vue'
import { isEmpty } from 'oderon-commons/src/utils'
import { InstalledBase } from '@/models'

export default {
  pageTitle: 'Base Instalada',
  components: { RowDetailsDialog, GenericReport, Indicators },
  data() {
    return {
      reportSpec: {
        code: 'installedBase',
        title: 'Base Instalada',
        apiBase: '/installed-base',
        filters: [
          {
            type: 'Text',
            placeholder: 'Filtro por palavras-chave',
            prefix: 'keywords',
            icon: 'mdi-magnify',
            size: 'sm',
            debounceMs: 250
          },
          {
            type: 'Switch',
            label: 'Ocultar veículos sem módulo',
            prefix: 'hideNoClient',
            showInMenu: true
          },
          {
            type: 'Switch',
            label: 'Ocultar módulos sem veículo',
            prefix: 'hideNoVehicle',
            showInMenu: true
          },
          {
            type: 'Switch',
            label: 'Ocultar módulos com veículo',
            prefix: 'hideWithVehicle',
            showInMenu: true
          },
          // {
          //   type: 'Switch',
          //   label: 'Ocultar módulos extraviados',
          //   prefix: 'hideLost',
          //   showInMenu: true
          // },
          {
            type: 'Switch',
            label: 'Ocultar módulos que já possuem ticket',
            prefix: 'hideWithTicket',
            showInMenu: true
          },
          {
            type: 'Switch',
            label: 'Ocultar a org Exemplo',
            prefix: 'hideExemplo',
            showInMenu: true,
            defVal: true
          },
          {
            type: 'Switch',
            label: 'Mostrar apenas linhas com problemas',
            prefix: 'onlyWithProblems',
            showInMenu: true
          },
          {
            type: 'Switch',
            label: 'Mostrar apenas linhas com pendência de checklist',
            prefix: 'onlyPendingChecklist',
            showInMenu: true
          },
          {
            type: 'Operator',
            prefix: 'operators',
            noSuffix: true,
            showInMenu: true
          },
          {
            type: 'Depot',
            prefix: 'depot',
            showInMenu: true
          },

          {
            type: 'Firmware',
            prefix: 'fwVersions',
            noSuffix: true,
            useVersionAsId: true,
            showInMenu: true
          },
          {
            type: 'LostStatus',
            prefix: 'lostStatus',
            noSuffix: true,
            showInMenu: true,
            defVal: [
              {id: 'active', name: 'Ativos'}
            ]
          }
        ]
      },

      stats: null
    }
  },
  methods: {
    go({ row, isMiddle }) {
      let id = row.id,
        [clientId, vehicleId] = id.split(':')

      if (isMiddle) {
        let url = `/clients/${clientId}`
        if (isEmpty(clientId)) {
          let orgId = Math.floor(+vehicleId / 10000)
          let idInOrg = +vehicleId % 10000
          url = `/vehicles/${orgId}/${idInOrg}`
        }

        window.open(`/#${url}`, '_blank')
      } else {
        this.$refs.detailsDialog.open(id)
      }
    },

    async fetchStats() {
      this.stats = await InstalledBase.getStats()
    },

    clickPendingTicket() {
      let filter = this.$refs.report.filter
      filter.onlyWithProblems = true
      filter.hideWithTicket = true
    },

    clickPendingChecklist() {
      let filter = this.$refs.report.filter
      filter.onlyPendingChecklist = true
    }
  }
}
</script>

<style></style>
